module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#facebook",
      toString: function () {
        return this.url;
      }
    }